<div class="loading" *ngIf="loading">
    <img class="load" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/loader.gif" alt="">
</div>

<div class="remodal" *ngIf="!loading">
    <div class="gui-cont">
        <div class="tit-gui">
            <h3>Detalle de guía #</h3>

            <input *ngFor="let gui of array" type="text" value="{{gui}}" disabled>

        </div>
        <table class="table">
            <tbody>
                <tr>
                    <td class="td-tit">Fecha de generacion:</td>
                    <td>{{pedidos.fecha_produccion}}</td>
                </tr>
                <tr>
                    <td>
                        <span>Estado:</span>
                        <br *ngIf="!novedad"> <span *ngIf="!novedad">Novedad:</span>
                        <br *ngIf="!novedad"> <span *ngIf="!novedad">Aclaracion:</span>
                    </td>
                    <td>
                        <span>{{pedidos.estado}}</span>
                        <br *ngIf="!novedad"><span style="color: #d4001b;" *ngIf="!novedad">{{novedad3}}</span>
                        <br *ngIf="!novedad"><span *ngIf="!novedad">{{aclaracion}}</span>

                    </td>
                </tr>
                <tr>
                    <td>Ciudad origen:</td>
                    <td>{{pedidos.ciudad_origen}}</td>
                </tr>
                <tr>
                    <td>Ciudad destino:</td>
                    <td>{{pedidos.ciudad_destino}}</td>
                </tr>
                <tr>
                    <td>Nombre remitente:</td>
                    <td>{{pedidos.nombre_remitente}}</td>
                </tr>
                <tr>
                    <td>Nombre destinatario:</td>
                    <td>{{pedidos.nombre_destinatario}}</td>
                </tr>
                <tr>
                    <td>Unidades:</td>
                    <td>{{pedidos.unidades}}</td>
                </tr>
                <tr>
                    <td>Peso:</td>
                    <td>{{pedidos.peso_real}}</td>
                </tr>
                <tr>
                    <td>Volumen:</td>
                    <td>{{pedidos.volumen}}</td>
                </tr>
                <tr>
                    <td>Valor declarado:</td>
                    <td>${{valor}}</td>
                </tr>
                <tr>
                    <td>Dice contener:</td>
                    <td>{{pedidos.contenido}}</td>
                </tr>
                <tr>
                    <td>Estimado entrega:</td>
                    <td>{{pedidos.estimado_entrega}}</td>
                </tr>
                <tr>
                    <td>Dias cubrimiento:</td>
                    <td>{{pedidos.dias_cubrimiento}}</td>
                </tr>
                <tr>
                    <td>Cuenta:</td>
                    <td>{{cuenta}}</td>
                </tr>
                <tr>
                    <td>Servicio:</td>
                    <td>{{pedidos.servicio_utilizado}}</td>
                </tr>
                <tr>
                    <td>Fecha entrega:</td>
                    <td>{{pedidos.fecha_entrega}}</td>
                </tr>
                <tr>
                    <td>Hora entrega:</td>
                    <td>{{pedidos.hora}}</td>
                </tr>
                <tr>
                    <td>Memo SAC</td>
                    <td>{{pedidos.memosac}}</td>
                </tr>
                <tr>
                    <td>Texto guía:</td>
                    <td>{{pedidos.nombre_destinatario}}</td>
                </tr>
                <tr>
                    <td>Documentos:</td>
                    <td>{{pedidos.documentos}}</td>
                </tr>
                <tr>
                    <td>Fecha recoleccion:</td>
                    <td>{{pedidos.fec_recoleccion}}</td>
                </tr>
                <tr>
                    <td>Fecha despacho:</td>
                    <td>{{pedidos.fec_despacho}}</td>
                </tr>
                <tr>
                    <td>Fecha reparto:</td>
                    <td>{{pedidos.fec_reparto}}</td>
                </tr>
            </tbody>
        </table>
        <div class="gui-prub" *ngIf="!imagen">
            <a href="{{pedidos.imagen}}" download="imagen.jpg" target="_blank">Ver prueba de entrega
                <i class="fas fa-download"></i>
            </a>
        </div>
    </div>
</div>